import { createApp } from 'vue';
import ElementPlus, { ElDialog, ElEmpty } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import '@/assets/styles/base.scss';
import '@/views/open-portal/portal-theme.scss';
import emptyStateImage from '@/assets/empty-state.svg';
import App from './App.vue';
import router from './router';
import './permission';

ElDialog.props.closeOnClickModal.default = false;
ElEmpty.props.image.default = emptyStateImage;

createApp(App).use(router).use(ElementPlus, { locale: zhCn }).mount('#app');
